import { EProductVariantConnectionStatus } from '@gelato-api-ui/core/e-commerce/e-product-variant-connection-status.enum';
import { ProductTypeUid } from '../product-catalogue/product-type-uid.enum';

export interface EProductSearchRequest {
  clientId?: string;
  storeId: string;
  limit: number;
  offset: number;
  connectionStatus: EProductVariantConnectionStatus;
  ids?: string[];
  productTypeUids?: ProductTypeUid[];
  title?: string;
  hasDraft?: number;
  order?: OrderCriteria;
  orderBy?: EProductSearchOrderByField;
}

export enum OrderCriteria {
  ASC = 'asc',
  DESC = 'desc',
}

export enum EProductSearchOrderByField {
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
  TEMPLATE_NAME = 'templateName',
}
